/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, OnInit, ChangeDetectionStrategy, SkipSelf, ViewChild } from '@angular/core';

import { from, of } from 'rxjs';
import { delay, concatMap, last } from 'rxjs/operators';

import { UntypedFormControl } from '@angular/forms';

import { LoadingBlockerState } from 'src/app/common/utility-components/loading-blocker';

import { PopupCoreService } from 'src/app/common/popup/popup-core.service';
import { PopupAnchor } from 'src/app/common/popup/popup-anchor.directive';
import { SimplePopupComponent } from 'src/app/common/popup/simple-popup/simple-popup.component';
import { PopupService } from 'src/app/common/popup/popup.service';
import { LoggerServiceFactory } from 'src/app/common/logging/LoggerServiceFactory';
import { DefaultLoggerService, ILoggerService } from '@touchplan/logging';

@Component({
	selector: 'harness',
	templateUrl: './harness.component.html',
	styles: [],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [PopupService, LoggerServiceFactory.provide('HarnessComponent')],
})
export class HarnessComponent implements OnInit {
	public mediumCheckbox = new UntypedFormControl(false);
	public largeCheckbox = new UntypedFormControl(true);
	public smallCheckbox = new UntypedFormControl(false);

	public toggleBlockTest = false;

	public loadingState = LoadingBlockerState.empty;
	public startLoadingObs = false;
	public loadingObservable = from([
		LoadingBlockerState.inProgress,
		LoadingBlockerState.complete,
		LoadingBlockerState.empty,
		LoadingBlockerState.inProgress,
		LoadingBlockerState.failure,
	]).pipe(concatMap((x) => of(x).pipe(delay(300))));

	// @ViewChild(PopupAnchor, {static: true}) popupAnchor: PopupAnchor //static is v8 only
	// @ViewChild(PopupAnchor) popupAnchor: PopupAnchor

	//@SkipSelf() private popupService: PopupService
	constructor(
		private popupService: PopupService,
		@SkipSelf() private popupServiceParent: PopupService,
		private logger: DefaultLoggerService
	) {}

	public ngOnInit() {
		this.logger.log('harness init');

		// this.mediumCheckbox.valueChanges.subscribe(thing => {
		// 	this.logger.log('thing', thing);
		// })
	}

	public testPopup(blockBackground?: boolean) {
		const popup = this.popupService.create(SimplePopupComponent, blockBackground);
		popup.output$.pipe(last()).subscribe((out) => {
			Logging.notice('popup output: ' + out.type + ', ' + out.data);
		});
		popup.open();
	}
	public testParentPopup(blockBackground?: boolean) {
		const popup = this.popupServiceParent.create(SimplePopupComponent, blockBackground);
		popup.output$.pipe(last()).subscribe((out) => {
			Logging.notice('popup output: ' + out.type + ', ' + out.data);
		});
		popup.open();
	}
	public testMultiPopup() {
		const popups = [
			this.popupServiceParent.create(SimplePopupComponent, true),
			this.popupServiceParent.create(SimplePopupComponent, true),
		];
		const openDatas = [{}, { descriptionText: 'popup 2' }];

		const obs = this.popupService.openMultiPopup(popups, openDatas);
		obs.subscribe((test) => {
			this.logger.log('multi popup output', test);
		});
	}

	//checkbox testing
	public setCheckbox(checkboxControl: UntypedFormControl) {
		checkboxControl.setValue(!checkboxControl.value);
	}

	//loding blocker testing

	public setLoadingState(state: LoadingBlockerState) {
		this.loadingState = state;
	}

	public setLoadingEmpty() {
		this.setLoadingState(LoadingBlockerState.empty);
	}
	public setLoadingComplete() {
		this.setLoadingState(LoadingBlockerState.complete);
	}
	public setLoadingFailure() {
		this.setLoadingState(LoadingBlockerState.failure);
	}
	public setLoadingInProgress() {
		this.setLoadingState(LoadingBlockerState.inProgress);
	}

	public logHarnessOutput(state) {
		Logging.notice('blocker state: ' + state);
	}
}
